var _rect, _circle, _circle2, _circle3, _path, _circle4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _ellipse, _ellipse2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle5, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebDev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "webDev",
    xmlns: "http://www.w3.org/2000/svg",
    width: 307.141,
    height: 159.148,
    viewBox: "0 0 307.141 159.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 90.874,
    height: 161.095,
    transform: "translate(109.331 89.302) rotate(-74.21)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 1.284,
    cy: 1.284,
    r: 1.284,
    transform: "translate(135.453 4.231)",
    fill: "#16c389"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 1.284,
    cy: 1.284,
    r: 1.284,
    transform: "translate(139.407 5.349)",
    fill: "#16c389"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 1.284,
    cy: 1.284,
    r: 1.284,
    transform: "translate(143.36 6.467)",
    fill: "#16c389"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M755.122,356.755a15,15,0,0,0-6.264.148,14.974,14.974,0,0,0,.443-6.33,14.885,14.885,0,0,0-5.6,3.613,14.885,14.885,0,0,0-2.878-6.011,14.971,14.971,0,0,0-2.938,5.624,15,15,0,0,0-5.259-3.407,12.018,12.018,0,0,0,7.991,14.071l.019.023.01-.012c.084.032.13.048.13.048s.018-.091.042-.254l.046-.057.009.073c-.064.152-.1.239-.1.239s.048.011.136.027l0,.015.029-.01a12.018,12.018,0,0,0,14.177-7.8Z",
    transform: "translate(-538.794 -299.41)",
    fill: "#16c389"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 3.338,
    cy: 3.338,
    r: 3.338,
    transform: "translate(205.308 38.522)",
    fill: "#16c389"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 104.248,
    height: 2.268,
    transform: "translate(150.245 56.832) rotate(15.79)",
    fill: "#16c389"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 17.974,
    height: 17.974,
    transform: "translate(156.56 70.358) rotate(15.79)",
    fill: "#16c389"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 17.974,
    height: 17.974,
    transform: "translate(188.68 79.441) rotate(15.79)",
    fill: "#16c389"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 17.974,
    height: 17.974,
    transform: "translate(220.801 88.525) rotate(15.79)",
    fill: "#16c389"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 13.352,
    height: 1.541,
    transform: "translate(152.915 91.742) rotate(15.79)",
    fill: "#16c389"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 13.352,
    height: 1.541,
    transform: "translate(185.035 100.825) rotate(15.79)",
    fill: "#16c389"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 13.352,
    height: 1.541,
    transform: "translate(217.156 109.908) rotate(15.79)",
    fill: "#16c389"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 85.928,
    cy: 3.177,
    rx: 85.928,
    ry: 3.177,
    transform: "translate(1.694 116.79)",
    fill: "#d0cde1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 66.867,
    cy: 3.177,
    rx: 66.867,
    ry: 3.177,
    transform: "translate(173.408 152.795)",
    fill: "#d0cde1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M778.172,621h19.291v8.067H786.24v8.067h11.224V645.2H778.172Zm23.15,0h19.291v7.015H809.389v1.4h11.224v16.135H801.322v-7.367h11.224v-1.4H801.321V621Zm23.15,0h19.291v7.015H832.539v1.4h11.224v16.135H824.472v-7.367H835.7v-1.4H824.472V621Z",
    transform: "translate(-570.693 -489.687)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M220.926,499h7.958v7.862h7.28V499h7.959v23.81h-7.958v-7.973h-7.28v7.973h-7.958V499Zm33.661,7.9h-7V499h21.974v7.9h-7.009V522.81h-7.958V506.9h0Zm18.456-7.9h8.3l5.1,8.366,5.1-8.366h8.3v23.81h-7.926v-11.8l-5.475,8.466h-.137l-5.479-8.466v11.8h-7.786Zm30.763,0h7.961v15.94h11.191v7.87H303.807V499Z",
    transform: "translate(-182.05 -404.6)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M80.529,366.091l-.653,7.4,5.225-.436v-6.314Z",
    transform: "translate(-55.708 -255.325)",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M55.664,366.091l.653,7.4-5.225-.436v-6.314Z",
    transform: "translate(-35.633 -255.325)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M148.055,365.276s1.742,10.451,1.742,11.975-.653,11.322-1.742,13.281-1.306,2.83-.871,3.7.218.653,0,1.306-.653.435,0,1.306a2.287,2.287,0,0,1,0,2.613c-.435.653.871,18.289-.871,19.6s-2.177,5.661-2.177,5.661l-5.661-.653v-4.79s-1.306-3.484-.435-5.661,1.306-13.717,1.306-13.717a4.325,4.325,0,0,1,0-1.742.969.969,0,0,0-.435-1.306c-.435-.218-.653-1.089-.653-1.089l-.653-15.894-2.613,15.676s2.613,21.337,0,24.168v5.008h-5.661l.871-5.443s-1.742-5.008-.871-6.1-2.613-18.507-2.177-19.16.218-.871,0-1.306-.871-.871-.653-1.306a2.5,2.5,0,0,0,0-1.306s-4.137-20.466-2.177-22.426S148.055,365.276,148.055,365.276Z",
    transform: "translate(-114.308 -311.336)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M169.475,564.7s.435-2.088,3.919-1.371a9.383,9.383,0,0,1,.871,2.677c0,.871.871,6.749.871,6.749s3.484,5.879-.871,5.879-5.879-1.524-6.1-3.048.218-1.96-.653-2.613-1.306-.653-1.089-1.524.653-5.225.653-5.225.218-3.266,1.415-2.395l1.2.871",
    transform: "translate(-144.001 -449.36)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M140.391,564.7s-.435-2.088-3.919-1.371A9.383,9.383,0,0,0,135.6,566c0,.871-.871,6.749-.871,6.749s-3.484,5.879.871,5.879,5.879-1.524,6.1-3.048-.218-1.96.653-2.613,1.306-.653,1.089-1.524-.653-5.225-.653-5.225-.218-3.266-1.415-2.395l-1.2.871",
    transform: "translate(-121.014 -449.36)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 5.879,
    cy: 5.879,
    r: 5.879,
    transform: "translate(19.813 2.121)",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M154.963,216.319s-2.395,9.362-2.83,9.58,10.015,1.089,10.015,1.089-2.613-8.056,0-9.362Z",
    transform: "translate(-134.061 -207.448)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M139.914,235.172h0l-7.179,4.964,1.306,38.973s9.58-1.089,11.757-.871,9.144-1.96,9.144-1.96l-3.052-36.621a3.008,3.008,0,0,0-2.786-2.751l-1.308-.092s-1.306,3.234-5.236,1.566A4.586,4.586,0,0,1,139.914,235.172Z",
    transform: "translate(-120.541 -220.596)",
    fill: "#d0cde1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M128.5,234l-8.877,4.23-1.742,25.038s-3.484,15.023-.653,19.378a11.026,11.026,0,0,0,7.62,4.79s6.314-25.038,4.572-33.53S128.5,234,128.5,234Z",
    transform: "translate(-108.952 -219.78)",
    fill: "#575a89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M101.34,358.8v3.266s-1.306,7.185,2.83,6.967,2.177-7.838,2.177-7.838l-1.306-2.395Z",
    transform: "translate(-98.509 -306.819)",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M217.88,379.383l-.435,3.7s2.177,7.4-1.96,7.62-1.134-7.575-1.134-7.575l1.352-4.182Z",
    transform: "translate(-176.729 -320.872)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M179.552,238.085h0a25.641,25.641,0,0,1,10.722,5.574l.038.033L187.264,259.8l-.435,5.879s8.056,28.74-1.306,24.6c0,0-8.056-25.038-6.967-36.578S179.552,238.085,179.552,238.085Z",
    transform: "translate(-152.428 -222.629)",
    fill: "#575a89"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M203.392,255.773c.218-.218,2.83.3,2.83.3s4.79,16.9,4.79,19.728.653,18.942.653,18.942l-5.747.579-4.652-22.386Z",
    transform: "translate(-168.338 -234.928)",
    fill: "#575a89"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M104.629,247.981H103.1s-4.354,1.742-4.572,3.7-6.1,21.772-6.1,21.772L93.96,283.47l5.661-.871,1.089-11.1,5.661-12.193Z",
    transform: "translate(-92.436 -229.53)",
    fill: "#575a89"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M158.7,196.641l.225-1.571c.053-.366.267-.848.623-.748.3.085.963.344,1.074.266.414-.293,1.04.22,1.476-.041.182-.109.3-.343.513-.359a.585.585,0,0,1,.377.171,2.564,2.564,0,0,0,.975.53,1.049,1.049,0,0,0,1.027-.28.545.545,0,0,1,.182-.174.408.408,0,0,1,.261.012l1.112.3a4.274,4.274,0,0,0-.572-3.519,7.078,7.078,0,0,0-1.62-1.587q-1.033-.786-2.133-1.479a6.927,6.927,0,0,0-2.591-1.127,2.767,2.767,0,0,0-2.578.855,1.66,1.66,0,0,1-.6-.807.611.611,0,0,0,.039.937l-.941-.6c-.264.278.252.781.027,1.091a.575.575,0,0,1-.253.165,4.312,4.312,0,0,0-1.379.868,5.147,5.147,0,0,0-1.086,2c-.561,1.608-.968,3.452-.172,4.958.09.171,1.282,2.987,1.441,3.1.537.371.187-.527.572,0,.3.413.245-1.169.693-.822a1.117,1.117,0,0,0,1.216.055c.186-.129.126-.845.026-1.5a.774.774,0,0,1,.942-.871A3.371,3.371,0,0,0,158.7,196.641Z",
    transform: "translate(-134.146 -187)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M117.655,134.02l2.395,19.813h-1.524Z",
    transform: "translate(-82.057 -93.471)",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M31.39,108.834l-1.211,7.62,2.3-7.62H31.39Z",
    transform: "translate(-21.048 -75.905)",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDev);
export default __webpack_public_path__ + "static/media/webDev.3a66fa4e84ea0db01915f4c927045666.svg";
export { ForwardRef as ReactComponent };